import { render, staticRenderFns } from "./FlowConfig01Edit.vue?vue&type=template&id=2106d5a0&scoped=true&"
import script from "./FlowConfig01Edit.vue?vue&type=script&lang=js&"
export * from "./FlowConfig01Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106d5a0",
  null
  
)

export default component.exports